import { gql } from "graphql-request";

// `ItemId` is not selected: this schema declares its own `itemId` field, which
// hides the system one, so asking for `ItemId` fails the whole query. The row is
// identified by `OrganizationId` (there is one row per organization).
//
// Kept apart from GET_ORGANIZATION_CONFIGS (logo, used by the nav bar): if the
// `enabledFeatures` field is ever missing from a project's schema, only this
// query fails, and every feature simply reads as off.
export const GET_ORG_FEATURES = gql`
  query GetOrgFeatures($where: organizationconfigFilterInput) {
    getorganizationconfigs(
      where: $where
      paging: { pageNo: 1, pageSize: 1 }
    ) {
      items {
        OrganizationId
        enabledFeatures
      }
    }
  }
`;

export const INSERT_ORG_FEATURES = gql`
  mutation InsertOrgFeatures($enabledFeatures: [String]) {
    insertorganizationconfig(input: { enabledFeatures: $enabledFeatures }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Targeted by OrganizationId, like the other org config updates: there is one
// config row per organization.
export const UPDATE_ORG_FEATURES = gql`
  mutation UpdateOrgFeatures(
    $organizationId: String!
    $enabledFeatures: [String]
  ) {
    updateorganizationconfig(
      where: { OrganizationId: { eq: $organizationId } }
      input: { enabledFeatures: $enabledFeatures }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;
